import React from "react";
import { Paper, Stack, Typography, Skeleton, Box, alpha } from "@mui/material";

/**
 * Wrapper para gráficos con título y acciones - Diseño mejorado
 */
export default function ChartCard({
  title,
  subtitle,
  children,
  actions,
  height = 300,
  loading = false,
  color = "primary",
}) {
  const colorGradients = {
    primary: "linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)",
    secondary: "linear-gradient(135deg, #8B5CF6 0%, #6D28D9 100%)",
    success: "linear-gradient(135deg, #10B981 0%, #059669 100%)",
  };

  const gradient = colorGradients[color] || colorGradients.primary;

  if (loading) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 4,
          height: "100%",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <Stack spacing={2}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="rectangular" width={80} height={32} sx={{ borderRadius: 2 }} />
          </Stack>
          <Skeleton variant="rectangular" height={height} sx={{ borderRadius: 3 }} />
        </Stack>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 4,
        height: "100%",
        position: "relative",
        overflow: "hidden",
        border: "1px solid",
        borderColor: "divider",
      }}
    >
      {/* Background decoration */}
      <Box
        sx={{
          position: "absolute",
          top: -50,
          right: -50,
          width: 150,
          height: 150,
          background: gradient,
          opacity: 0.04,
          borderRadius: "50%",
          filter: "blur(40px)",
        }}
      />

      <Stack spacing={2.5} sx={{ position: "relative" }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="h6" fontWeight={700}>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {subtitle}
              </Typography>
            )}
          </Box>
          {actions && <Box>{actions}</Box>}
        </Stack>

        <Box
          sx={{
            height,
            minHeight: height,
            borderRadius: 3,
            overflow: "hidden",
            bgcolor: (theme) => alpha(theme.palette.background.default, 0.5),
            p: 1,
          }}
        >
          {children}
        </Box>
      </Stack>
    </Paper>
  );
}
